Ext.define('SA.EditPanelEnabledSection', {
    alias: 'widget.edit-panel-enabled-section',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel-enabled-section',

    eachItem(callback) {
        this.getChildItems().forEach(callback);
    },

    findItem(dataId) {
        return this.getChildItems().find(item => item.getDataId() === dataId);
    },

    getIds() {
        return this.getChildItems().map(item => item.getDataId());
    }
});
